import React from "react";

import { ExamConfigData } from "@examspark/types";

export const ExamConfigContext = React.createContext<
  ExamConfigData | undefined
>(undefined);

export const ExamFlagsContext = React.createContext<
  | Partial<{
      textToSpeech: boolean;
      lineReader: boolean;
      highlighter: boolean;
      responseMasking: boolean;
      tiCalculator: boolean;
    }>
  | undefined
>(undefined);

export const ExamToolsContext = React.createContext<
  | {
      isResponseMasking: boolean;
    }
  | undefined
>(undefined);
